import { Component, OnInit, Pipe, PipeTransform } from "@angular/core";
import { Router } from "@angular/router";
import { NotificationService } from "src/app/Service/notification.service";
import { OtherService } from "src/app/Service/other.service";
import axios from "src/app/Service/axios";
import { DomSanitizer } from "@angular/platform-browser";
import TileLayer from 'ol/layer/Tile';
import { MapService } from 'src/app/Service/map.service';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import * as olProj from 'ol/proj';
import {
  DragRotateAndZoom,
  defaults as defaultInteractions, Draw
} from 'ol/interaction';
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { Polygon } from "ol/geom";
import Feature from "ol/Feature";
import { Fill, Stroke, Style } from "ol/style";
import BingMaps from "ol/source/BingMaps";
import { defaults as defaultControls, FullScreen } from 'ol/control';
import { DeviceDetectorService } from "ngx-device-detector";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { GurdServiceService } from "src/app/Service/gurd-service.service";
import { XYZ } from "ol/source";
declare let $: any;
declare var bootstrap: any;

@Component({

  selector: 'advertiseTaxi',

  templateUrl: './advertiseTaxiComponent.html',

})

export class AdvertiseTaxiComponent implements OnInit {
  constructor(
    private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private formBuilder: FormBuilder,
    private mapService: MapService,
    private gurdService: GurdServiceService
  ) { }
  listTaxiAdds: any;
  fullTaxiAdds: any;
  strWaw: string = "";
  ismapCreate: boolean = false;
  source: any;
  vector: any;
  layers: any = [];
  map: any;
  polygonEvent: any;
  draw: any;
  domain: any;
  mapSatelait: boolean = false;
  taxiADS: any;
  groupCar: any;
  carType: any;
  isEdite: boolean = false;

  private bOfflineMap: boolean = (<any>window).bOfflineMap;
  private strMapUrl: string = (<any>window).strMapUrl;

  datatFrom: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });

  datatTo: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });

  saveAdd: FormGroup = this.formBuilder.group({
    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),
    strSession: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('Session')!)),
    tiGPSType: new FormControl("-1"),
    tiMobileGroup: new FormControl("-1"),
    iMobileDomain: new FormControl("-1"),
    bDoman: new FormControl(false),
    iMaxPlay: new FormControl(),
    strApplicant: new FormControl(),
    strSubject: new FormControl(),
    strETime: new FormControl(),
    strSTime: new FormControl(),
    strEDate: new FormControl(),
    strSDate: new FormControl(),
    geoDomain: new FormControl(""),
    iDuration: new FormControl(),
    bMusic: new FormControl(false),


  });

  ngOnInit(): void {
    this.getAddsList();
    this.getDomain();
    this.getGroup();
    this.getGpsType();
    //timePicker
    $('.clockpicker').clockpicker({
      donetext: 'top',
      align: 'top',
      autoclose: true,
    });
    //Handel Close Modal
    $("#wawModal").on("hidden.bs.modal", () => {
      this.strWaw = "";
    });

    $("#addModal").on("hidden.bs.modal", () => {
      this.isEdite = false;
      this.resetForm();
    });
  }
  seprator(e: any) {
    if (isNaN(e.key)) {
      return false;
    }
    this.otherService.insertComma(e);
    return true;
  }
  getAddsList = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    const resp = await axios.post(`Taxi_ListTaxiAds`, model);
    resp.data = JSON.parse(resp.data);
    this.listTaxiAdds = resp.data;
    this.fullTaxiAdds = resp.data;

  }
  deleteAdds = async (id: any) => {
    $.confirm({
      title: `آیا از حذف این تبلیغ اطمینان دارید ؟`,
      content: '',
      type: 'red',
      buttons: {
        ok: {
          text: "حذف",
          btnClass: 'btn-success',
          keys: ['enter'],
          action: async () => {
            var model = {
              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
              iTaxiADS: id
            } as any;
            const resp = await axios.post(`Taxi_DeleteTaxiAds`, model);
            resp.data = JSON.parse(resp.data);
            if (resp.data.iResult == 1) {
              this.notifyService.showSuccess("با موفقیت حذف شد");
              this.fullTaxiAdds = this.fullTaxiAdds.filter((el: any) => {
                return el.iTaxiADS != id;
              });
              this.listTaxiAdds = this.listTaxiAdds.filter((el: any) => {
                return el.iTaxiADS != id;
              });

            }
            else {
              this.notifyService.showError(resp.data.strError)
            }
            return;

          }
        },
        cancel: {
          text: "لغو",

        }
      }
    });
  }
  getVoice = async (id: any) => {
    this.strWaw = "";
    const resp = await axios.get(`Taxi_GetAdsWaveFile?iTaxiADS=${id}`);
    this.strWaw = resp.data;
    $("#wawModal").modal("show");
  }
  newOpenMap = async (taxiADS: any) => {


    setTimeout(() => {
      if (!this.ismapCreate) {

        this.source = new VectorSource({ wrapX: false });

        this.vector = new VectorLayer({
          source: this.source,
        });

        if (this.bOfflineMap) {

          this.layers.push(

            new TileLayer({

              source: new XYZ({

                // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

                url: this.strMapUrl,

                attributions: 'Map data © RayanAndishehNasr' // 

              }),

            })

          );
        }

        else {

          const styles = [

            'AerialWithLabelsOnDemand',

          ];

          let i, ii;
          for (i = 0, ii = styles.length; i < ii; ++i) {
            this.layers.push(
              new TileLayer({
                visible: false,
                preload: Infinity,
                source: new BingMaps({
                  // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                  key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                  imagerySet: styles[i],
                }),

              }),
            );
          }
          
          this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector)
        }

        this.map = new Map({
          layers: this.layers,
          target: 'map',
          view: new View({
            center: olProj.fromLonLat([51.3833554, 35.6770113]),
            zoom: 13,
          }),
        });

        //Handel Add Polygon
        this.vector.getSource().on('addfeature', (e: any) => {
          this.polygonEvent = e.feature;
          this.source.removeFeature(e.feature);
          this.source.removeFeature(this.polygonEvent);

          this.savePolygon();
        });
        //let draw: any;
        const value = 'Polygon';
        //if (value !== 'None') {
        this.draw = new Draw({
          source: this.source,
          type: value,
        });
        this.map.addInteraction(this.draw);
        this.ismapCreate = true;


      }
      else {
        return;
      }


      //}
    }, 500);

    setTimeout(async () => {

      this.taxiADS = taxiADS;
      var model = {
        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
        iTaxiADS: this.taxiADS,
      } as any;
      const resp = await axios.post(`Taxi_GetTaxiAdsDomain`, model);

      var resParse = JSON.parse(resp.data);
      var ring = [];
      this.mapService.removeLayerByName("polygon", this.map)
      if (resParse.length != 0) {
        var loc = resParse;
        for (let index = 0; index < loc.length; index++) {
          ring.push([loc[index].fLon, loc[index].fLat]);
        }
        var polygon = new Polygon([ring]);
        polygon.transform('EPSG:4326', 'EPSG:3857');
        var feature = new Feature(polygon);
        var vectorSource = new VectorSource();
        vectorSource.addFeature(feature);
        var vectorLayer = new VectorLayer({
          source: vectorSource,
          name: 'polygon',
          style: new Style({
            stroke: new Stroke({
              color: 'red',
              width: 4,
              lineDash: [10, 20, 10, 20]
            }),
            fill: new Fill({
              color: 'rgba(0, 0, 255, 0)'
            })
          }),
        } as any);
        this.map.addLayer(vectorLayer);
        this.mapService.fitMap(resParse, this.map);
        // this.map.getView().setZoom(17);

      }
    }, 700);

    //context menu
  }
  savePolygon = async () => {
    var point = [] as any;
    this.draw.sketchLineCoords_.forEach((item: any, index: any) => {
      var data = this.mapService.transformCoordinates(item);
      point.push({ fLat: data[1], fLon: data[0] });
    });
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      iTaxiADS: this.taxiADS,
      lstPoints: point
    } as any;
    $.confirm({
      title: `آیا از ثبت این محدوده اطمینان دارید ؟`,
      content: '',
      type: 'blue',
      buttons: {
        ok: {
          text: "ثبت",
          btnClass: 'btn-success',
          keys: ['enter'],
          action: async () => {

            const resp = await axios.post(`Taxi_UpdateTaxiAdsDomain`, model);
            resp.data = JSON.parse(resp.data);
            if (resp.data.iResult == 0) {
              this.notifyService.showSuccess("با موفقیت ثبت شد");
            }
            else {
              this.notifyService.showError(resp.data.strError);
            }
            return;

          }
        },
        cancel: {
          text: "لغو",
          action: async () => {
            return;
          }

        }
      }
    });
  }
  changeTail() {

    if (this.mapSatelait == false) {
      this.layers[1].setVisible(false);

      this.layers[0].setVisible(true);
    }
    else {
      this.layers[0].setVisible(false);

      this.layers[1].setVisible(true);
    }
    this.mapSatelait = !this.mapSatelait;

  }
  getDomain = async () => {
    const resp = await axios.post(
      `GetMobileDomain4Report?iSystemUser=${this.gurdService.decrypt(localStorage.getItem("ID")!)}`,
      {}
    );
    this.domain = JSON.parse(resp.data);
  }
  getGroup = async () => {
    const resp = await axios.post(`GetMobileGroup`, {});
    resp.data = JSON.parse(resp.data);
    this.groupCar = resp.data;
  };
  getGpsType = async () => {
    const resp = await axios.post(
      `GetGPSType`
    );
    this.carType = resp.data;
  }
  filter(e: any) {
    this.listTaxiAdds = this.fullTaxiAdds.filter((el: any) => {
      return el.strSubject.includes(e.value);
    });

  }
  save = async () => {
    var model = this.saveAdd.value;
    var Stime = document.getElementById("Stime") as any;
    var Etime = document.getElementById("Etime") as any;
    model.strSDate = this.datatFrom.value.date;
    model.strEDate = this.datatTo.value.date;
    model.strSTime = Stime.value;
    model.strETime = Etime.value;
    if (!model.strApplicant) {
      this.notifyService.showError("لطفا نام متقاضی را وارد کنید");
      return;
    }
    if (!model.strSubject) {
      this.notifyService.showError("لطفا عنوان را وارد کنید");
      return;
    }
    if (!model.iDuration) {
      this.notifyService.showError("لطفا مدت زمان تبلیغ را وارد کنید");
      return;
    }
    this.otherService.Showspinner();
    const resp = await axios.post(`Taxi_SaveTaxiAds`, model);
    this.otherService.nonespinner();
    resp.data = JSON.parse(resp.data);
    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strError);
    }
    else {
      this.notifyService.showSuccess("با موفقیت ثبت شد");
      this.listTaxiAdds.push(resp.data[0]);
      // this.fullTaxiAdds.push(resp.data[0]);
      this.resetForm();
    }
    var addModal = document.getElementById('addModal');
    var modal = bootstrap.Modal.getInstance(addModal)
    modal.hide();
  }
  editeMod(item: any) {
    this.isEdite = true;
    this.taxiADS = item.iTaxiADS;
    this.saveAdd.controls["tiGPSType"].setValue(item.tiGPSType);
    this.saveAdd.controls["tiMobileGroup"].setValue(item.tiMobileGroup);
    this.saveAdd.controls["iMobileDomain"].setValue(item.iMobileDomain);
    this.saveAdd.controls["bDoman"].setValue(item.bDoman);
    this.saveAdd.controls["iMaxPlay"].setValue(item.iMaxPlay);
    this.saveAdd.controls["strApplicant"].setValue(item.strApplicant);
    this.saveAdd.controls["strSubject"].setValue(item.strSubject);
    this.saveAdd.controls["strETime"].setValue(item.strETime);
    this.saveAdd.controls["strSTime"].setValue(item.strSTime);
    this.saveAdd.controls["strEDate"].setValue(item.strEDate);
    this.saveAdd.controls["strSDate"].setValue(item.strSDate);
    this.saveAdd.controls["geoDomain"].setValue(item.geoDomain);
    this.saveAdd.controls["iDuration"].setValue(item.iDuration);
    this.saveAdd.controls["bMusic"].setValue(item.bMusic);
    this.datatFrom.controls["date"].setValue(item.strSDate);
    this.datatTo.controls["date"].setValue(item.strEDate);
    var Stime = document.getElementById("Stime") as any;
    var Etime = document.getElementById("Etime") as any;
    Stime.value = item.strSTime;
    Etime.value = item.strETime;
  }
  resetForm() {
    this.saveAdd.reset({
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),
      tiGPSType: "-1",
      tiMobileGroup: "-1",
      iMobileDomain: "-1",
      bDoman: false,
      iMaxPlay: "",
      strApplicant: "",
      strSubject: "",
      strETime: "",
      strSTime: "",
      strEDate: "",
      strSDate: "",
      geoDomain: "",
      iDuration: "",
      bMusic: false,
    });
  }
  edit = async () => {
    var model = this.saveAdd.value;
    var Stime = document.getElementById("Stime") as any;
    var Etime = document.getElementById("Etime") as any;
    model.strSDate = this.datatFrom.value.date;
    model.strEDate = this.datatTo.value.date;
    model.strSTime = Stime.value;
    model.strETime = Etime.value;
    model.iTaxiADS = this.taxiADS;
    if (!model.strApplicant) {
      this.notifyService.showError("لطفا نام متقاضی را وارد کنید");
      return;
    }
    if (!model.strSubject) {
      this.notifyService.showError("لطفا عنوان را وارد کنید");
      return;
    }
    if (!model.iDuration) {
      this.notifyService.showError("لطفا مدت زمان تبلیغ را وارد کنید");
      return;
    }
    this.otherService.Showspinner();
    const resp = await axios.post(`Taxi_EditTaxiAds`, model);
    this.otherService.nonespinner();
    resp.data = JSON.parse(resp.data);
    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strError);
    }
    else {
      this.notifyService.showSuccess("با موفقیت ثبت شد");
      this.resetForm();
      this.listTaxiAdds = this.listTaxiAdds.filter((el: any) => {
        return el.iTaxiADS != this.taxiADS;
      });
      this.listTaxiAdds.push(resp.data[0]);
    }
    var addModal = document.getElementById('addModal');
    var modal = bootstrap.Modal.getInstance(addModal)
    modal.hide();
  }
  goBack() {
    this.router.navigateByUrl(`/`);;
  }
}
